export default "__VITE_ASSET__DNVYE2$Y__"